module.exports = __webpack_public_path__ + "media/images/icons/filled/funnel-plot-e9d514a224b8c909aa8942ab1aeb8669.svg";